import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* createTemplateWatcherSaga() {
  yield takeEvery(types.CREATE_TEMPLATE_API_CALL_REQUEST, workerSaga);
}

export function createData(data) {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/client/${client}/templates/`;

  return axios.post(url, data)
    .then(val => val)
    .catch(err => err.response);
}

export function* workerSaga(action) {
  try {
    const { data } = action;
    const response = yield call(createData, data);

    if (response && response.status >= 200 && response.status < 202) {
      yield put({ type: types.CREATE_TEMPLATE_API_CALL_SUCCESS, data });
    } else {
      yield put({ type: types.CREATE_TEMPLATE_API_CALL_FAILURE, error: response && response.data });
    }
  } catch (error) {
    yield put({ type: types.CREATE_TEMPLATE_API_CALL_FAILURE, 'error': error && error.data});
  }
}
